var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcError(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 96 96",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.41421
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "Error--",
    x: 0,
    y: 0,
    width: 96,
    height: 96,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.107,8.001c3.217,0.087 5.148,3.257 6.689,6.372c10.582,21.389 21.359,42.775 31.581,64.361c0.837,1.77 1.436,3.711 1.365,5.511c-0.119,2.091 -1.85,3.725 -3.944,3.725c-11.36,0.03 -59.722,0.03 -71.432,0.03c-1.106,0 -2.164,-0.455 -2.924,-1.259c-0.761,-0.803 -1.157,-1.884 -1.096,-2.989c0.183,-3.414 2.498,-7.59 4.446,-11.607c9.837,-20.283 20.075,-40.572 29.907,-60.795c1.021,-2.012 3.13,-3.37 5.408,-3.349Zm-1.394,13.28c-8.042,16.27 -22.814,46.432 -27.42,55.84c-0.303,0.62 -0.266,1.352 0.099,1.938c0.366,0.585 1.007,0.941 1.697,0.941c10.448,0 43.438,0 53.848,0c0.688,0 1.327,-0.353 1.693,-0.935c0.366,-0.583 0.408,-1.312 0.11,-1.932c-8.955,-18.605 -18.25,-37.234 -27.453,-55.852c0,0 0,-0.001 0,-0.001c-0.242,-0.49 -0.741,-0.799 -1.287,-0.799c-0.546,0 -1.045,0.309 -1.287,0.799c0,0 0,0 0,0.001Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 72,
    r: 4,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5,40.5c0,-1.932 -1.568,-3.5 -3.5,-3.5c-1.932,0 -3.5,1.568 -3.5,3.5l0,20c0,1.932 1.568,3.5 3.5,3.5c1.932,0 3.5,-1.568 3.5,-3.5l0,-20Z",
    style: {
      fill: "#fff"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcError);
export default __webpack_public_path__ + "static/media/ic_error.c66e0e62f3aa6219bc5341ee973eb798.svg";
export { ForwardRef as ReactComponent };